import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Classic — serif, centered header, uppercase section headings with rule.
export const classicStyles = {
  meta: { label: "Classic (serif)" },

  page: {
    ...SPACING.pagePadding,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.serif,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.4,
  },

  header: {
    alignItems: "center",
    textAlign: "center",
    marginBottom: 8,
  },
  headerName: {
    fontSize: TYPE.name,
    fontFamily: FONTS.serifBold,
    letterSpacing: 0.5,
    color: COLORS.navy,
    marginBottom: 12,
  },
  headerHeadline: {
    fontSize: TYPE.headline,
    color: COLORS.slate,
    marginTop: 2,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: COLORS.slate,
    marginTop: 6,
    textAlign: "center",
  },
  sep: { color: COLORS.mute },

  section: { marginTop: SPACING.sectionGap },
  sectionHeadingWrap: {
    borderBottomWidth: 0.75,
    borderBottomColor: COLORS.navy,
    paddingBottom: 2,
    marginBottom: 6,
  },
  sectionHeading: {
    fontSize: TYPE.sectionHeading,
    fontFamily: FONTS.serifBold,
    textTransform: "uppercase",
    letterSpacing: 1.5,
    color: COLORS.navy,
  },

  itemGroup: { marginBottom: SPACING.itemGap },
  itemGroupTight: { marginBottom: 4 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.serifBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { fontFamily: FONTS.serifBold },
  itemTitleMuted: { fontFamily: FONTS.serif, color: COLORS.slate },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.serifItalic,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: { fontSize: TYPE.meta, color: COLORS.slate },

  body: { fontSize: TYPE.body, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 2 },
  chipsLine: { fontSize: TYPE.body, marginTop: 2 },
  labelStrong: { fontFamily: FONTS.serifBold },
  italic: { fontFamily: FONTS.serifItalic },

  bullets: { marginTop: 4 },
  bulletRow: { flexDirection: "row", marginBottom: 2 },
  bulletMark: { width: 10, fontSize: TYPE.body, color: COLORS.navy },
  bulletText: { flex: 1, fontSize: TYPE.body, color: COLORS.navy },

  link: { color: COLORS.rust, textDecoration: "underline", },
  linkSmall: {
    color: COLORS.rust,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
